export default __webpack_public_path__ + "static/media/ApplePay.28698346.svg";